// NOTE: Commented out cache to check if it causes memory leak.
import { ThemeEnum } from '~/enums/Region'
import { getCurrentTheme } from '../locale/getCurrentTheme'
import type { RuntimeConfig } from '@nuxt/schema'
import { assets } from './assets'

type AssetLoader = () => Promise<{ default: string }>

interface ThemeAssetIcons {
  [key: string]: string
}

interface QuoteBenefits {
  benefits: ThemeAssetIcons
  steps: ThemeAssetIcons
}

interface ThemeAssets {
  quoteBenefits?: QuoteBenefits
  orderForm?: ThemeAssetIcons
  howItWorks?: ThemeAssetIcons
  logos: ThemeAssetIcons
  facebookLogo: ThemeAssetIcons
  usp: ThemeAssetIcons
  whyJoin: ThemeAssetIcons
}

interface AssetsConfig {
  [theme: string]: ThemeAssets
}

class AssetManager {
  // private cache: Record<string, Record<string, string>>
  private assets: AssetsConfig

  constructor() {
    // @ts-expect-error
    this.assets = assets
    // this.cache = {}
  }

  private async loadAssetsRecursively(
    assetsObject: Record<string, AssetLoader | Record<string, any>>,
    basePath: string,
    theme: ThemeEnum
  ): Promise<Record<string, any>> {
    const results: Record<string, any> = {}

    for (const key in assetsObject) {
      const value = assetsObject[key]
      const currentPath = basePath ? `${basePath}.${key}` : key

      if (typeof value === 'object' && !('default' in value)) {
        results[key] = await this.loadAssetsRecursively(value, currentPath, theme)
      } else if (typeof value === 'function') {
        // if (!this.cache[theme]) this.cache[theme] = {}
        // if (!this.cache[theme][currentPath]) {
        //   const asset = await (value as AssetLoader)()
        //   this.cache[theme][currentPath] = asset.default
        // }

        const asset = await (value as AssetLoader)()
        results[key] = asset.default
      }
    }

    return results
  }

  async getAssets(key: keyof ThemeAssets, config: RuntimeConfig): Promise<Record<string, string>> {
    const theme = getCurrentTheme(undefined, config)
    const themeAssets = this.assets[theme]?.[key] || this.assets[ThemeEnum.SHIPZEE]?.[key]

    if (!themeAssets) {
      return {}
    }

    return await this.loadAssetsRecursively(
      themeAssets as unknown as Record<string, AssetLoader | Record<string, any>>,
      key,
      theme
    )
  }

  async getQuoteBenefits(config: RuntimeConfig) {
    return (await this.getAssets('quoteBenefits', config)) as unknown as QuoteBenefits
  }

  async getOrderForm(config: RuntimeConfig) {
    return await this.getAssets('orderForm', config)
  }

  async getHowItWorks(config: RuntimeConfig) {
    return (await this.getAssets('howItWorks', config)) as unknown as ThemeAssetIcons
  }

  async getLogo(config: RuntimeConfig) {
    return (await this.getAssets('logos', config)) as unknown as ThemeAssetIcons
  }

  async getFbLogo(config: RuntimeConfig) {
    return (await this.getAssets('facebookLogo', config)) as unknown as ThemeAssetIcons
  }

  async getUspImages(config: RuntimeConfig) {
    return (await this.getAssets('usp', config)) as unknown as ThemeAssetIcons
  }

  async getBenefits(config: RuntimeConfig) {
    return (await this.getAssets('whyJoin', config)) as unknown as ThemeAssetIcons
  }

  async getProHowItWorks(config: RuntimeConfig) {
    return (await this.getAssets('proHowItWorks', config)) as unknown as ThemeAssetIcons
  }
}

export default new AssetManager()
